import React from "react";
import { Result, Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { all_routes } from "Router/all_routes";
import ImageWithBasePath from "core/img/imagewithbasebath";

const Unauthorized = ({ error }) => {
  const navigate = useNavigate();

  return (
    // <div className="main-wrapper">
    //   <div className="page-wrapper">
    //     <div className="content">
    //       <div className="error-box">
    //         <div className="error-img">
    //           <ImageWithBasePath
    //             src="assets/img/authentication/access-denied.png"
    //             className="img-fluid"
    //             alt="Error"
    //           />
    //         </div>
    //         <h3 className="h2 mb-3">Oops, {error}</h3>
    //         <p>Contact your administrator</p>
    //         <Link to={all_routes.dashboard} className="btn btn-primary">
    //           Back to Dashboard
    //         </Link>
    //       </div>
    //     </div>
    //   </div>
    // </div>

    <div className="main-wrapper">
      <div className="page-wrapper">
        <div className="content">
          <Result
            status="403"
            title="403 - Unauthorized"
            subTitle="Sorry, you are not authorized to access this page."
            extra={
              <Button type="primary" onClick={() => navigate("/")}>
                Back to Home
              </Button>
            }
          />
        </div>
      </div>
    </div>
  );
};

Unauthorized.propTypes = {
  error: PropTypes.string,
};
export default Unauthorized;
